import React from "react";
import { withRouter } from "react-router";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import NotFound from "../../containers/NotFound/NotFound";

function mapStateToProps(state) {
  return {
    user: state.auth.user,
  };
}

const PrivateRoute = ({ component: Component, location, isBeta, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const loggedIn = rest.user && rest.user.token;
      const showBeta = isBeta ? Boolean(process.env.BETA) : true;

      if (!loggedIn) {
        return (
          <Redirect
            push
            to={{
              pathname: "/login",
              search: `?redirect=${location.pathname}${location.search}`,
              state: { from: location },
            }}
          />
        );
      }

      if (!showBeta) return <NotFound />;

      return <Component {...props} />;
    }}
  />
);

export default withRouter(connect(mapStateToProps)(PrivateRoute));
